import { Image } from "@/models/image";
import { Profile } from "@/models/profile";

export enum CollectUserData {
    Disabled = "disabled",
    Optional = "optional",
    Required = "required",
}

export interface Campaign {
    id: string;
    promptText: string;
    termsText: string;
    privacyText: string;
    successText?: string;
    successLink?: string;
    successLinkLabel?: string;
    enforcesTermsAndConditionsConsent: boolean;
    enforcesPrivacyPolicyConsent: boolean;
    contributionURL: string;
    hideBeamsBranding: boolean;
    status: string;
    color?: string;
    backgroundColor?: string;
    image?: Image;
    profile: Profile;
    canAcceptResponses: boolean;
    privacyURL?: string;
    termsURL?: string;
    termsAndConditionsConsentText?: string;
    privacyPolicyConsentText?: string;
    maximumRecordingDuration?: number;
    backgroundImage?: Image;
    isNPSCampaign: boolean;
    NPSQuestion: string;
    promptSublineText?: string;
    recordButtonLabel?: string;
    isCSATCampaign: boolean;
    CSATQuestion?: string;
    interfaceLanguage: string;
    collectNames: CollectUserData;
    collectEmails: CollectUserData;
    collectImages: CollectUserData;
    videoURLs?: string[];
    conversationalSurvey: boolean;
    newRecorder: boolean;
    agentWelcomeMessage?: string;
    successShareEnabled: boolean;
    textFieldDefault: boolean;
}
